module.exports = __webpack_public_path__ + "static/img/title.eca76155.png";